var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAk1BMVEUAAAD/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDQ3wHd4AAAAMHRSTlMA8unG1Nt5VtdxMh7lzry3gmpTT0U4LQfu38upZEEMsI9+bmA9JRDBvqSgSykW9fQ2+aOnAAABW0lEQVQ4y52U63KCMBBGExJA5CaKIlRFxHu1zfs/XVMW0hSWOOP59Tl72MhuBvImq+TOckqD4naYGrSECY3C241ouehheYjmRwKBPfpeSgXO/L83F6PUurcVBj7/vKcwclIiM4t2523EC5xWXKu52bxgl2sUXS+s4LalzExvmLs+/FZkvjvRW/Im0zNByKBr8Jsf8NCeoFRQXcp4gLjBNLWJSsZ7b1XTFbKKWMYQYtqVvG4a8BhUJzIG6l8ACzlhV4mndnAyUojqQrtNh27BPlTpmGgthqI1PNpKkKORl9nv0Je59cazPI6MxzMO3IXqTMaVcYUOVJtT4IasM1TM1buoZfN0cH92R9ad3PAlAGqHLIrLD0kZRyy01Y1ux5AIE9AQ4GYvIB2+WdTu3cLkuUSjHvc8JZl71oNvbYhpkyW2rXVf+54RlLPDdc2ePckoW6fkAaUWj6uUvMcPkFWMIgvrHoEAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutubeIcon);
export default __webpack_public_path__ + "static/media/footer-youtube-icon.23847e71c17f3eeff823665ed073fb80.svg";
export { ForwardRef as ReactComponent };